import { TasksFiltersEnum } from 'pages/tasks/types/types';

export const getPopoverWidth = (fieldName: TasksFiltersEnum, booleanFilters: TasksFiltersEnum[]) => {
  if (fieldName === TasksFiltersEnum.ReasonForFailure) return 'auto';

  if (booleanFilters.includes(fieldName)) return 80;

  return 222;
};
